export default __webpack_public_path__ + "static/media/next-button-icon.3143afe4.svg";